/** * TooltipComponent.vue **/
<template>
  <!-- TooltipComponent template file -->
  <transition appear>
    <div
      v-portal="'#tooltip-portal'"
      class="tooltip-component-container"
      :style="getPosition"
      :class="[
        position,
        { multiline },
        { multilineSmall },
        { multilineManual },
      ]"
    >
      <p>{{ text }}</p>
    </div>
  </transition>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import vPortal from '@/directives/portal'

defineOptions({ name: 'TooltipComponent' })

const props = withDefaults(
  defineProps<{
    bbox?: DOMRect | null
    text: string | number
    position?: string
    margin?: number
    multiline?: boolean
    multilineSmall?: boolean
    multilineManual?: boolean
  }>(),
  {
    bbox: null,
    position: 'top',
    margin: 12,
    multiline: false,
    multilineSmall: false,
    multilineManual: false,
  },
)

const getPosition = computed<Record<string, string>>(() => {
  const bbox = props.bbox
  if (!bbox) {
    return {} as Record<string, string>
  }
  if (props.position === 'bottom') {
    return {
      top: bbox.top + bbox.height + 'px',
      left: bbox.left + bbox.width / 2 + 'px',
    }
  } else if (props.position === 'left') {
    return {
      top: bbox.top - bbox.height / 2 + 'px',
      left: bbox.left - props.margin + 'px',
    }
  } else if (props.position === 'right') {
    return {
      top: bbox.top - bbox.height / 2 + 'px',
      left: bbox.left + bbox.width + props.margin + 'px',
    }
  } else {
    return {
      top: bbox.top - props.margin + 'px',
      left: bbox.left + bbox.width / 2 + 'px',
    }
  }
})
</script>
<style scoped lang="scss" src="./tooltip-component.scss"></style>
